module.exports = __webpack_public_path__ + "img/plus-circle-outline.826a1a01.png";